require('./dropDown.less');

/* wraps $.fn.dropDown -- $el of the view is the opener */
var Marionette = require('marionette'),
    _ = require('underscore'),
    $ = require('jquery');

require('jqDropDown');

//TODO: just listing ... would be on proto

var instVars = {
    template: '',   /*req'd* -- if not existing markup , IF DD.OPTIONS.$CONTENT IS NOT GIVEN */
    templateOptions: null, //apply from instances -- can be fn / obj -- optional
    onChange: null, //apply from inst. - req'd if onChange $.fn option
    defaultSelector: null, /*optional -- fn or str */
    dropdown: null, //the instance of the dd created with the $.fn.dropDown on this.el
    ddOptions: {}
};


module.exports = Marionette.ItemView.extend({

    initialize: function(options) { /* el is the opener */

        this.ddOptions = _.extend({}, _.result(this, 'ddOptions'), options.ddOptions);
    },
    render: function() {
        var opts = _.extend( {}, this.ddDefaults(), this.ddOptions);
        this.dropdown = this.$el.dropDown(opts);
        this.triggerMethod('render', this);
        return this;
    },
    ddDefaults: function() {
        var content = this.ddOptions.$content
                ? this.ddOptions.$content
                : this._templateContentAndID().content,

            //el in onOpen
            onChange = this.onChange ? _.bind(this.onChange, this) : null, /* must bind to this if want cb to be inside dd instance -- otherwise cxt is plugin $opener */
            defaultSelector = this.defaultSelector ? _.result(this, 'defaultSelector') : null,
            defaults = {
                content: content,
                applyIframeShim: true
            };
        /* extend with optional settings if exist on inst */
        content.id && _.extend( defaults, {id: templateData.id}); //todo: i don't think template data still exists ...
        onChange && _.extend( defaults, {onChange: onChange});
        defaultSelector && _.extend( defaults, {defaultSelector: defaultSelector});
        return defaults;
    },
    _templateContentAndID: function() { //return the content for the dropdown (combo b/c need markup for id)
        var templateOpts = _.result(this, 'templateOptions'),
            content = templateOpts ? this.template(templateOpts) : this.template(),
            templateId = $(content).attr('id');
        return {
            content: content,
            id: templateId
        };
    },
    getDDContent: function() {
        return this.dropdown.getDDEl(); /* hook into the plugin */
    },
    onBeforeDestroy: function() {
        this.dropdown.destroy();
        this.dropdown[0] = null; //still ref here
        this.dropdown = null;
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/dropDown/dropDownWr.js
 ** module id = 432
 ** module chunks = 0
 **/